import { PropsWithChildren } from 'react';

import { cn } from '@components/primitives/utilities';

import { useCheckboxContext } from './context';

import css from './styles.module.css';

export interface CheckboxLabelProps extends PropsWithChildren {
  className?: string;
}

/**
 * The checkbox's label, wired to the control so clicking it toggles.
 *
 * Lays its children out in a row, so an icon or a trailing badge is written
 * inline rather than passed in through a prop. Pass `className="sr-only"` for
 * a control whose visible label lives elsewhere.
 */
export function CheckboxLabel({ className, children }: CheckboxLabelProps) {
  const { id } = useCheckboxContext();

  return (
    <label htmlFor={id} className={cn(css.label, className)}>
      {children}
    </label>
  );
}
